<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="after-invoice-details">
      <div class="filter-search">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="添加日期：">
            <el-date-picker size="small" v-model="searchData.operateTime" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getSourceInvoice">搜索</el-button>
            <a class="export-button" :disabled="!ExportSourceInvoicePower" :href="exportUrl" target="_blank">导出数据</a>
            <el-button type="primary" size="small" @click="addBillInfo" :disabled="!addSourceInvoicePower || status != '1'">添加发票明细</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
          <el-table-column align="center" fixed="left" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="changeBillInfo(scope.row)" type="text" size="small" :disabled="status === 3 || !updateSourceInvoicePower">修改</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatDater" prop="AddDate" label="添加日期" min-width="110">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="OperatorName" label="操作员" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="MediaId" label="媒体商ID" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="CompanyName" label="公司名称" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceOperator" label="媒体运营" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="Medium" label="媒介" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="ContractCompany" label="合同公司" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="PaymentCompany" label="打款公司" min-width="130">
          </el-table-column>
          <el-table-column prop="InvoiceImg" label="发票图片" min-width="130">
            <template slot-scope="scope">
              <img :src="scope.row.InvoiceImg" alt="" width="80" @click="showImage(scope.row)">
            </template>
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="InvoiceHeader" label="发票抬头" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="InvoiceTypeStr" label="发票类型" min-width="130">
          </el-table-column>
          <el-table-column align="center" prop="SourceInvoiceNumber" label="票据号码" min-width="250">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="ActualAmount" label="发票金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="BillingContent" label="备注" width="180">
          </el-table-column>
        </el-table>
        <!-- <el-pagination background layout="prev, pager, next" :total="dataSize" :current-page="currentPage" @current-change="pageChange">
      </el-pagination> -->
      </div>
      <!-- 图片放大弹层 -->
      <el-dialog :visible.sync="IsShowImage" width="50%">
        <div class="image-content">
          <span class="close-image-modal" @click="IsShowImage = false">×</span>
          <img :src="imageUrl" alt="" @error="imgError">
        </div>
      </el-dialog>
    </div>
    <!-- 弹层设置 -->
    <addInvoiceDialog v-if="isShowDiaLog" @close='closeDialog' :dialogPragram="dialogPragram"></addInvoiceDialog>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
import addInvoiceDialog from "../public/import-preview/add-invoice-dialog";
import { formatDateAll } from "common/js/common";
// api
import {
  getSourceInvoiceList,
  getSourceOperatorUserList,
  getSourceUserList,
  AddSourceInvoice,
  UpdateSourceInvoice
} from "api/mediaWithdraw";

export default {
  data() {
    return {
      searchData: {
        operateTime: ""
      },
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "媒体提现审核",
          href: "IAD_MediaDraw"
        },
        {
          trail: "发票明细",
          href: ""
        }
      ],
      dataSize: 0,
      isShowDiaLog: false,
      imageUrl: "",
      IsShowImage: false,
      dialogPragram: {
        title: "提示",
        data: "",
        callback: null
      },
      tableData: [],
      currentPage: 1,
      SourceOperatorUserList: [],
      SourceUserList: [],
      isRouterEnter: true,
      status: 0
    };
  },
  computed: {
    exportUrl() {
      var filterData = {
        BusinessId: this.$route.params.id,
        BeginAddDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        EndAddDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      var url = `/IAD_MediaDraw/ExportSourceInvoice?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    },
    addSourceInvoicePower() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .AddSourceInvoice;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    updateSourceInvoicePower() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .UpdateSourceInvoice;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ExportSourceInvoicePower() {
      if (this.$store.state.authorization.IAD_MediaDraw) {
        if (this.$store.state.authorization.IAD_MediaDraw.PageFuncs) {
          return this.$store.state.authorization.IAD_MediaDraw.PageFuncs
            .ExportSourceInvoice;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  components: {
    crumbs,
    addInvoiceDialog
  },
  methods: {
    // 获取媒体运营数据
    initData() {
      // 获取媒体运营数据
      getSourceOperatorUserList().then(res => {
        this.SourceOperatorUserList = Object.assign(
          {},
          this.SourceOperatorUserList,
          res.list
        );
      });
      //  获取媒介数据
      getSourceUserList().then(res => {
        this.SourceUserList = Object.assign({}, this.SourceUserList, res.list);
      });
      this.status = this.$route.params.status;
    },
    // 获取发票明细列表
    getSourceInvoice() {
      var filterData = {
        BusinessId: this.$route.params.id,
        BeginAddDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        EndAddDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      getSourceInvoiceList(filterData)
        .then(res => {
          if (res.list) {
            this.tableData = res.list;
          } else {
            this.tableData = [];
          }
          // 如果是页面跳转增加发票明细显示增加发票明细弹层
          if (this.isRouterEnter) {
            this.dialogPragram.title = "添加发票";
            this.isShowDiaLog = true;
            this.dialogPragram.callback = this.addSourceInvoice;
          }
        })
        .catch(err => {
          this.tableData = [];
        });
    },
    // 关闭发票增加和修改弹层
    closeDialog() {
      this.isShowDiaLog = false;
    },
    // 开启增加发票明细弹层
    addBillInfo() {
      this.dialogPragram.title = "添加发票";
      this.isShowDiaLog = true;
      this.dialogPragram.data = "";
      this.dialogPragram.callback = this.addSourceInvoice;
    },
    // 开启修改发票明细弹层
    changeBillInfo(row) {
      this.dialogPragram.title = "修改发票";
      this.dialogPragram.data = row;
      this.isShowDiaLog = true;
      this.dialogPragram.callback = this.updateSourceInvoice;
    },
    // 显示放大查看图片
    showImage(row) {
      this.imageUrl = row.InvoiceImg;
      this.IsShowImage = true;
    },
    imgError() {
      this.imageUrl = require("../../common/img/b_img.png");
    },
    // 格式化日期
    formatDater(row, column, cellValue, index) {
      return formatDateAll(cellValue);
    },
    // 分页切换页码
    // pageChange(currentPage) {
    //   this.currentPage = currentPage;
    //   this.getMediaInfo();
    // },
    // 添加发票明细
    addSourceInvoice(data) {
      data.BusinessId = this.$route.params.id;
      AddSourceInvoice(data).then(res => {
        this.isShowDiaLog = false;
        if (this.isRouterEnter) {
          this.$router.back();
        } else {
          this.getSourceInvoice();
        }
      });
    },
    // 更新发票明细
    updateSourceInvoice(data) {
      data.BusinessId = this.$route.params.id;
      UpdateSourceInvoice(data).then(res => {
        this.isShowDiaLog = false;
        this.getSourceInvoice();
      });
    }
  },
  created() {
    document.title = "发票明细";
    this.getSourceInvoice();
    this.initData();
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 路由进入，如果跳转路由存在，并且是增加发票信息，显示增加发票弹层；

      if (from.name === null || to.name === "afterInvoiceDetailsReview") {
        vm.isRouterEnter = false;
      } else {
        vm.isRouterEnter = true;
      }
    });
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.after-invoice-details {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-input {
      width: 140px;
    }
    .el-select {
      .el-input {
        width: 110px;
      }
    }
    .el-date-editor {
      width: 240px;
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
    }
    .el-icon-menu:before {
      font-size: 24px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-button {
      margin: 0;
      width: 100%;
      font-size: 14px;
    }
    thead {
      tr {
        background-color: #f5f5f5 !important;
        border-bottom: 2px solid #bbb;
        text-align: center;
      }
    }
    // .el-pagination {
    //   text-align: center;
    //   margin: 30px 0;
    // }
  }
  .image-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    .close-image-modal {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 28px;
      color: #e5e5e5;
      background-color: #fff;
      line-height: 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/after-invoice-details.vue